import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLAuthImpersonationClient, ImpersonationHandoffModel } from "./api/cplauthapi/CPLAuthAPI";

export interface IImpersonationService {
  getImpersonationToken(clientPortalUserID: string): Promise<ImpersonationHandoffModel>;
}

@injectable()
export class ImpersonationService implements IImpersonationService {
  @inject(SERVICE_TYPES.CPLAuthImpersonationClient) cplAuthImpersonationClient!: ICPLAuthImpersonationClient;

  async getImpersonationToken(clientPortalUserID: string): Promise<ImpersonationHandoffModel> {
    return this.cplAuthImpersonationClient.getImpersonationToken(clientPortalUserID);
  }
}
